import { Centerdiv } from "./Centerdiv";
export const Viewport = () => {
  return (
    <>
      <div className="viewport-background">
        <div className="content-grid">
          <Centerdiv />
        </div>
      </div>
    </>
  );
};
